import firebase from "firebase/app";
import "firebase/auth";

export default async (_, data, context) => {
	return await firebase
		.auth()
		.currentUser.getIdToken()
		.then(token => token);
};
